import { SemantriaConfigurationDto } from '../../../../providers/semantria-api/configuration.service';
import { ImportStrategy } from './import-strategy';

export class OverrideImportStrategy implements ImportStrategy {
  doImport = (source, target, configIncludeData) => {
    const dto = JSON.parse(JSON.stringify(target));
    const itemsToCreate: any = {};
    const itemsToDelete: any = {};
    const itemsToUpdate: any = {};

    dto.notes = this.assembleNotes(source);
    dto.tags = this.assembleTags(source);

    if (!configIncludeData.includes.notes) {
      dto.notes = undefined;
    }

    if (!configIncludeData.includes.tags) {
      dto.tags = undefined;
    }

    Object.keys(configIncludeData.includes)
      .filter((k) => k !== 'notes' && k !== 'tags')
      .filter((k) => configIncludeData.includes[k])
      .forEach((k) => {
        itemsToDelete[k] = dto[k];
        dto[k] = [...(source[k] ?? [])];
        itemsToCreate[k] = [...dto[k]];
      });

    return {
      configDto: dto,
      itemsToCreate,
      itemsToDelete,
      itemsToUpdate,
    };
  };

  countItems = (source: SemantriaConfigurationDto, target, itemProps) => {
    const count = new Map<string, number>();

    itemProps.forEach((item) => count.set(item.prop, source[item.prop]?.length || 0));

    return count;
  };

  assembleNotes = (source: SemantriaConfigurationDto) => {
    return source.notes || '';
  };

  assembleTags = (source: SemantriaConfigurationDto) => {
    return source.tags || [];
  };
}
